const viewItemListTemplate = {
  event: 'view_item_list', // A default GA4 event
  item_list_id: null, // A literal
  filter_keywords: null, // The keywords that were used in the search, in base64
  performer_list_qty: null, // The total amount of performers returned
  event_list_qty: null, // The total amount of events returned
  venue_list_qty: null, // The total amount of venues returned
  items: null,
};

export default viewItemListTemplate;
